// extracted by mini-css-extract-plugin
export var copyIcon = "_yj-2";
export var discountCard = "_yj-0";
export var discountCode = "_yj-3";
export var discountContent = "_yj-1";
export var loadingCard = "_yj-4";